class AuthEvents {
  // Singleton instance
  private static instance: AuthEvents | null = null;
  private listeners: { [event: string]: Function[] } = {};
  private allEventsListeners: Function[] = [];

  subscribe(event: string, listener: Function) {
    if (event === '*') {
      this.allEventsListeners.push(listener);
    } else {
      if (!this.listeners[event]) {
        this.listeners[event] = [];
      }
      this.listeners[event]?.push(listener);
    }
  }

  publish(event: string, data?: any) {
    const listeners = this.listeners[event];

    if (listeners) {
      for (const listener of listeners) {
        listener(event,data);
      }
    }

    for (const listener of this.allEventsListeners) {
      // execute the callback function for all event listeners
      listener(event, data);
    }
  }

  public static getInstance(): AuthEvents {
    if (!AuthEvents.instance) {
      AuthEvents.instance = new AuthEvents();
    }
    return AuthEvents.instance;
  }
}

// Singleton instance
const authHub = AuthEvents.getInstance();
export { authHub as AuthEvents };